import type {Labeled} from 'typings/portaro.be.types';

export type LocFilter = (obj: any) => string;

declare global {
    // eslint-disable-next-line @typescript-eslint/no-namespace
    namespace angular {
        interface IFilterService {
            // eslint-disable-next-line @typescript-eslint/prefer-function-type
            (name: 'loc'): LocFilter;
        }
    }
}

// @formatter:off
/**
 * @ngdoc filter
 * @name loc
 * @module portaro.filters
 * @kind function
 *
 * @param {object} obj Input localization object. If not defined, returns `null`
 *
 * @return {string|null} Localization text
 *
 * @description
 * Filter returns `text` property from input object
 *
 * @example
 * ```
 * <example name="locExample" module="locExample" frame-no-resize="true">
 *  <file name="index.html">
 *      <main ng-init="input = {text: 'Hello'}">
 *          <div>
 *              <label>Input: </label><span>{{input | json}}</span>
 *          </div>
 *          <div>
 *              <label>Output: </label><span>{{input | loc}}</span>
 *          </div>
 *      </main>
 *  </file>
 *  <file name="script.js">
 *      angular.module('locExample', ['portaro.filters']);
 *  </file>
 * </example>
 * ```
 */
// @formatter:on
export default function locFilter(): LocFilter {
    return (obj: any) => {
        if (angular.isDefined(obj) && obj !== null) {
            let res = obj;

            if (isLabeled(res)) {
                res = res.text;
            }

            return res;
        }

        return null;
    };
}

function isLabeled(obj: any): obj is Labeled {
    return obj && angular.isDefined(obj.text);
}

locFilter.filterName = 'loc';
